import React from 'react';

import FormManager from "../form-manager";
import ButtonDeprecated from "../../../gd-components/buttons/gd-button/gd-button";
import {ButtonSize, ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new";

const debug = {
    dev: false,
    head: '[Form BtnSubmit]'
};

// const propTypes = {
//     onClick: PropTypes.any,
//     label: PropTypes.string.isRequired,
//     className: PropTypes.string,
//     size: PropTypes.string,
//
//     icon: PropTypes.string,
//     iconPosition: PropTypes.oneOf(['left','right']),
//
//     form: PropTypes.object.isRequired,
//
//     hideIfDisabled: PropTypes.bool // hide (no render) when form not ready for submit
// };

// const defaultProps = {
//     iconPosition: 'left'
// };

type Props = {
    form            : FormManager,

    className?      : string,

    icon?           : string,
    iconPosition?   : 'left' | 'right'

    type?           : ButtonType | 'primary' | 'normal' | 'secondary' | 'blue' | 'gray' | 'busy' | 'disabled'
    hideIfDisabled? : boolean

    size?       : ButtonSize | '30' // need typing submit bttn size ?
    label       : string // button label
}

export default class ButtonSubmitDeprecated extends React.Component<Props> {

    constructor(props) {
        super(props);

        // this._bind('onClick');
    }

    componentDidMount() {
        this.props.form.registerSubmitButton(this);
    }

    onClick = (e) => {
        e.stopPropagation();

        if (this.props.type === 'busy') {
            e.preventDefault();
        } else {
            //this.props.onClick(e);
            this.props.form.onSubmitClick.call(this.props.form);
        }
    };

    render() {
        const { form, hideIfDisabled } = this.props;

        let type : ButtonType = ButtonType.PRIMARY

        if (form.isSubmitting) type = ButtonType.BUSY
        else if (form.isFormValid && form.isFormChanged) type = ButtonType.PRIMARY

        if (hideIfDisabled === true && type !== 'primary' && type !== 'busy') {
            return false;
        }

        if (debug.dev) console.log(debug.head, ".render() TYPE=", type, " formIsSubmitting=", this.props.form.isSubmitting, " formIsValid=", this.props.form.isFormValid, " formIsChanged=", this.props.form.isFormChanged);

        return (
            <ButtonDeprecated onClick={this.onClick}
                    size={this.props.size}
                    type={type}
                    label={this.props.label}
                    icon={this.props.icon}
                    iconPosition={this.props.iconPosition}
                    className={this.props.className}/>
        );

    }
}

// ButtonSubmit.propTypes = propTypes;
// ButtonSubmit.defaultProps = defaultProps;

// module.exports = ButtonSubmit;